import CallCentreApi from '@/api/CallCentreApiAxiosPlugin'
import DashboardListItemModel from '@/models/dashboards/dashboard-list-item-model'

export default class DashboardsController {
  public static async GetDashboardsAsync(): Promise<DashboardListItemModel[]> {
    const res = await CallCentreApi.get<DashboardListItemModel[]>('dashboards')
    return res.data
  }
}
